import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface TaskCreationMenu {
  config: LinkNavTab[]
}

export const useTaskCreationMenu = (): TaskCreationMenu => {
  const route = useRoute()

  const config: LinkNavTab[] = [
    {
      text: 'Task Info',
      to: AppRoute.TasksKanbanCreation,
      selected: route.path === AppRoute.TasksKanbanCreation,
      disabled: false,
      visible: true,
    },
    {
      text: 'Log',
      to: AppRoute.TasksKanbanLog,
      selected: false,
      disabled: true,
      visible: true,
    },
  ]

  return {
    config,
  }
}
